<table mat-table [dataSource]="processedData" class="mentor-mentee-table" matSort (matSortChange)="onSortChange($event)">
  <ng-container matColumnDef="avatar">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let user">
      <img [src]="user.imageUrl || 'assets/profile_image.png'" class="avatar" alt="" />
    </td>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'translations.global.label.firstName' | transloco }}</th>
    <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'translations.global.label.lastName' | transloco }}</th>
    <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
  </ng-container>

  <ng-container matColumnDef="menteesCount">
    <th mat-header-cell *matHeaderCellDef class="mentor-mentee-table__count">
      {{ 'translations.mentors.table.assignedMentees' | transloco }}
    </th>
    <td mat-cell *matCellDef="let user">
      <div class="mentor-mentee-table__count">
        <span>{{ user.menteesCount }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="mentorsCount">
    <th mat-header-cell *matHeaderCellDef class="mentor-mentee-table__count">
      {{ 'translations.mentors.table.assignedMentors' | transloco }}
    </th>
    <td mat-cell *matCellDef="let user">
      <div class="mentor-mentee-table__count">
        <span>{{ user.mentorsCount }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="studentsCount">
    <th mat-header-cell *matHeaderCellDef class="mentor-mentee-table__count">{{ 'translations.jobs.assignedStudents' | transloco }}</th>
    <td mat-cell *matCellDef="let user">
      <div class="mentor-mentee-table__count">
        <span>{{ user.studentsCount }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="evaluatorsCount">
    <th mat-header-cell *matHeaderCellDef class="mentor-mentee-table__count">{{ 'translations.jobs.assignedSupervisors' | transloco }}</th>
    <td mat-cell *matCellDef="let user">
      <div class="mentor-mentee-table__count">
        <span>{{ user.evaluatorsCount }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="assignedAt">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'translations.global.label.assignedAt' | transloco }}
    </th>
    <td mat-cell *matCellDef="let user">
      <ng-container *ngIf="isPendingApproval(user); else showDate">
        {{ 'translations.global.label.pendingApproval' | transloco }}
      </ng-container>
      <ng-template #showDate>
        {{ user.since | dateFormat: 'DD MMM yyyy HH:mm' }}
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="jobs">
    <th mat-header-cell *matHeaderCellDef>{{ 'translations.global.label.jobs' | transloco }}</th>
    <td mat-cell *matCellDef="let user">
      <div class="jobs-cell" *ngIf="user.jobs?.length; else noJobs">
        <button
          class="job-chip"
          [class.job-chip--active]="hasActiveJob(user.jobs)"
          [class.job-chip--ended]="!hasActiveJob(user.jobs)"
          (click)="openJobsDialog(user); $event.stopPropagation()"
          type="button"
        >
          <span class="job-chip__title">
            {{ getActiveJob(user.jobs)?.title || getMostRecentJob(user.jobs)?.title }}
          </span>

          @if (user.jobs.length > 1) {
            <span class="job-chip__more">+{{ user.jobs.length - 1 }}</span>
          }
        </button>
      </div>
      <ng-template #noJobs>
        <span class="jobs-cell__empty">{{ 'translations.jobs.noJobsAssigned' | transloco }}</span>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="manage">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let user">
      <button *ngIf="!isMyHub" mat-button color="primary" (click)="viewDetails.emit(user)">
        {{ 'translations.global.button.manage' | transloco }}
      </button>

      <span [matTooltip]="'Active job required'" [matTooltipDisabled]="hasActiveJob(user.jobs) || viewMode != 'students'">
        <button
          *ngIf="isMyHub"
          type="button"
          [disabled]="!hasActiveJob(user.jobs) && viewMode == 'students'"
          mat-button
          color="primary"
          (click)="viewDetails.emit(user)"
        >
          {{ 'translations.viewProfile' | transloco }}
        </button>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="unseenChanges">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let user">
      <div class="mentor-mentee-table__status-container" *ngIf="user.hasUnseenChanges">
        <span class="status-dot pending" [matTooltip]="'translations.mentors.info.unseenChanged' | transloco"></span>
      </div>
    </td>
  </ng-container>

  <thead>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  </thead>
  <tbody>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.pending-approval]="isPendingApproval(row)"></tr>
  </tbody>
</table>
